const m = (e) => `0${e}`.slice(-2), a = (e, t) => t === "Backspace" || t === "Delete" || /[0-9]/.test(t) ? e : e.slice(0, -1), u = (e, t) => {
  if (typeof e != "number") return "";
  const r = e % 1 !== 0 ? 2 : 0;
  return Number(e).toFixed((t == null ? void 0 : t.decimalPlaces) ?? r).replace(".", ",").replace(/\d(?=(\d{3})+(?!\d))/g, "$&.");
};
export {
  u as formatNumber,
  a as formatNumberInput,
  m as formatTwoDigitNumber
};
